import React, { ReactNode } from "react";

import { ReactComponent as PlusIcon } from "src/images/plus-dark-grey.svg";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";
import { Dropdown, DropdownMenu } from "../Dropdown/Dropdown";
import { Button } from "../Button/Button";

interface AddToDropdownProps {
  children: ReactNode | ((closeDropdown: () => void) => ReactNode);
}

export function AddToDropdown({ children }: AddToDropdownProps) {
  return (
    <Dropdown toBottom>
      {(isOpen, setIsOpen) => (
        <>
          <Button
            size="large"
            variant="white"
            onClick={() => setIsOpen((prev) => !prev)}
            data-qa="add-to-dropdown-button"
          >
            <PlusIcon />
            <IDHFormattedMessage id="ws_add_to" defaultMessage="Add to" />
            ...
          </Button>
          <DropdownMenu isOpen={isOpen}>
            {typeof children === "function"
              ? children(() => setIsOpen(false))
              : children}
          </DropdownMenu>
        </>
      )}
    </Dropdown>
  );
}
